<script>
export default {
  name: 'Colunas3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2.5" y="4.5" width="5.5" height="15" rx="1.75" :fill="color" />
    <rect x="9.25" y="4.5" width="5.5" height="15" rx="1.75" :fill="color" />
    <rect x="16" y="4.5" width="5.5" height="15" rx="1.75" :fill="color" />
  </svg>
</template>
